"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.SLIDER_BEFORE = exports.SLIDER = exports.SWITCH_INPUT = exports.SWITCH = exports.TOGGLE = exports.DISABLED = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    DISABLED = (0, _cxs["default"])({
  cursor: "default",
  opacity: "0.6"
});

exports.DISABLED = DISABLED;
var TOGGLE = (0, _cxs["default"])({
  display: "flex",
  alignItems: "center"
});
exports.TOGGLE = TOGGLE;
var SWITCH = (0, _cxs["default"])({
  position: "relative",
  cursor: "pointer",
  display: "inline-block",
  width: "40px",
  height: "20px"
});
exports.SWITCH = SWITCH;
var SWITCH_INPUT = (0, _cxs["default"])({
  opacity: "0",
  width: "0",
  height: "0"
});
exports.SWITCH_INPUT = SWITCH_INPUT;

var SLIDER = function SLIDER() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      b = a.checked;
  return (0, _cxs["default"])({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    transition: ".4s",
    webkitTransition: ".4",
    borderRadius: "20px",
    backgroundColor: b ? _vars.COLOURS.cyan.jungleGreen.monkey : _vars.COLOURS.grey.mischka.russian
  });
};

exports.SLIDER = SLIDER;

var SLIDER_BEFORE = function SLIDER_BEFORE() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      b = a.checked;
  return (0, _cxs["default"])({
    position: "absolute",
    content: "\"\"",
    height: "16px",
    width: "16px",
    left: "3px",
    bottom: "2px",
    transition: ".4s",
    webkitTransition: ".4",
    borderRadius: "20px",
    zIndex: 1,
    backgroundColor: _vars.COLOURS.mono.white,
    transform: b ? "translateX(18px)" : 0
  });
};

exports.SLIDER_BEFORE = SLIDER_BEFORE;